import React from "react";

const Subtitle: React.FC = () => {
    return (
        <>
            Dash has evaluated how your selected location's spending compares to your target spending level and how strongly they align.
        </>
    );
};

export default Subtitle;
